module.exports = __webpack_public_path__ + "img/yyfw-icon.ee9aeac1.png";